<template>
  <div class="boxbgcolor xinjiangunion-api-configure">
    <!--左侧树形展示所有停车场-->
    <div class="left content-left">
      <AreaTree v-on:handleTreeClick="handleTreeClick"></AreaTree>
    </div>
    <div class="right content-right configure-right">
      <div class="content-right-left">
        <el-form ref="addOrEditForm" label-width="150px" :rules="rules" :model="payConfigure">
          <el-form-item label="APPID" prop="appid">
            <el-input v-model="payConfigure.appid" @focus="isParkingIdEmpty"></el-input>
          </el-form-item>
          <el-form-item label="服务商Id" prop="serproviderid">
            <el-input v-model="payConfigure.serproviderid" @focus="isParkingIdEmpty"></el-input>
          </el-form-item>
          <el-form-item label="签名证书密码" prop="signCertificatePassword">
            <el-input v-model="payConfigure.signCertificatePassword" @focus="isParkingIdEmpty"></el-input>
          </el-form-item>

          <el-form-item>
            <el-checkbox v-model="payConfigure.openFlag" label="是否启用" name></el-checkbox>
          </el-form-item>
        </el-form>
        <div class="submit">
          <el-button type="primary" size="medium" @click="addOrEdit">提交</el-button>
        </div>
      </div>
      <div class="content-right-right">
        <div class="content-right-right-inner">
          <div class="upload">
            <el-upload
              action="/api/parking/sikUnionpayQrcodePay/upload"
              multiple
              :limit="3"
              :disabled="authenStatus==0?true:false"
              :data="treeData"
              :headers="headers"
              :on-error="uploadError"
              :on-success="uploadSuccess"
              :file-list="fileList"
            >
              <el-button size="small" type="primary" @click="forbidUpload">点击上传</el-button>
            </el-upload>
          </div>
          <p
            class="upload-tip"
          >请上传加密证书，签名证书，验签证书，其中加密证书文件名为utp_prod_enc.cer，验签证书名为utp_prod_verify_sign.cer</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

import {
  xinjiangUnionPayUnionConfigureOne,
  xinjiangUnionPayUnionConfigureAddOrEdit,
} from "@/api/url";

import AreaTree from "@/page/commons/areaTree";

import Cookies from "js-cookie";

export default {
  data() {
    return {
      treeData: {
        parkingId: "",
      },
      authenStatus: 0,
      fileList: [],
      payConfigure: {
        id: "",
        // systemname:'',
        appid: "",
        signCertificatePassword: "",
        serproviderid: "",
        // secret:'',
        openFlag: false,
        parkingId: "",
      },
      headers: {
        Authorization: Cookies.get("Authorization"), //从cookie里获取token，并赋值  Authorization ，而不是token
      },
      rules: {
        // systemname: [
        //     { required: true, message: '请填写系统名称', trigger: 'blur' }
        // ],
        appid: [{ required: true, message: "请填APPID", trigger: "blur" }],
        signCertificatePassword: [
          { required: true, message: "请填写签名证书密码", trigger: "blur" },
        ],
        serproviderid: [
          { required: true, message: "服务商Id", trigger: "blur" },
        ],
        // secret: [
        //     {  required: true, message: '请填写公钥', trigger: 'blur' }
        // ],
        // openFlag: [
        //     { required: true, message: '请填写微信公众号名称', trigger: 'blur' }
        // ]
      },
    };
  },
  methods: {
    ...mapMutations(["getPage"]),
    //点击树的节点展示相应数据
    handleTreeClick: function (node, data) {
      this.resetForm();
      if (node.type == "parking") {
        this.authenStatus = 1;
        this.treeData.parkingId = node.id;
        this.payConfigureOne();
      } else {
        this.treeData.parkingId = "";
        this.payConfigure.id = "";
        this.payConfigure.appid = "";
        (this.payConfigure.serproviderid = ""),
          (this.payConfigure.signCertificatePassword = "");
        this.payConfigure.openFlag = false;
        // this.$message({
        //         message: '请选择车场！',
        //         type: 'warning'
        // });
      }
      // if(node.level==2){
      // 	this.treeData.parkingId=data.parent.data.id;
      // 	this.treeData.areaId=node.id;
      // }
    },
    payConfigureOne() {
      this.$postRequest(xinjiangUnionPayUnionConfigureOne(), {
        parkingId: this.treeData.parkingId,
      }).then((data) => {
        if (data.data) {
          this.treeData.parkingId = data.data.parkingId;
          // this.payConfigure.systemname=data.data.systemname;
          this.payConfigure.id = data.data.id;
          this.payConfigure.appid = data.data.appid;
          this.payConfigure.serproviderid = data.data.serproviderid;
          this.payConfigure.signCertificatePassword =
            data.data.signCertificatePassword;
          // this.payConfigure.secret=data.data.secret;
          this.payConfigure.openFlag = data.data.openFlag == "y" ? true : false;
        } else {
          // this.treeData.parkingId='';
          // this.payConfigure.systemname='';
          this.payConfigure.id = "";
          this.payConfigure.appid = "";
          this.payConfigure.serproviderid = "";
          this.payConfigure.signCertificatePassword = "";
          // this.payConfigure.secret='';
          this.payConfigure.openFlag = false;
        }
      });
    },
    addOrEdit() {
      if (!this.treeData.parkingId) {
        this.$message({
          message: "请选择车场！",
          type: "warning",
        });
        return;
      }
      this.$refs.addOrEditForm.validate((valid) => {
        if (valid) {
          this.$postRequest(xinjiangUnionPayUnionConfigureAddOrEdit(), {
            id: this.payConfigure.id,
            parkingId: this.treeData.parkingId,
            // systemname:this.payConfigure.systemname,
            serproviderid: this.payConfigure.serproviderid,
            appid: this.payConfigure.appid,
            // secret:this.payConfigure.secret,
            signCertificatePassword: this.payConfigure.signCertificatePassword,
            openFlag: this.payConfigure.openFlag ? "y" : "n",
          }).then((data) => {
            //提交后的操作
            if (data.status != 200) return this.$layer.msg(data.message);
            this.$notify({
              type: "success",
              title: "成功",
              message: "新增或修改配置成功!",
            });
          });
        } else {
        }
      });
    },
    uploadError(err, file, fileList) {
      // console.log(err)
      this.$notify({
        type: "error",
        title: "上传失败",
        message: "上传失败,重新上传!",
      });
    },
    uploadSuccess(response, file, fileList) {
      //  console.log(response)
      if (response.status != 200) {
        this.$notify({
          type: "warning",
          title: "失败",
          message: response.message,
        });
        return;
      }
      this.$notify({
        type: "success",
        title: "成功",
        message: "文件上传成功!",
      });
    },
    isParkingIdEmpty() {
      if (!this.treeData.parkingId) {
        this.$message({
          message: "请选择车场！",
          type: "warning",
        });
      }
    },
    forbidUpload() {
      if (!this.treeData.parkingId) {
        this.$message({
          message: "请选择车场！",
          type: "warning",
        });
      }
      this.authenStatus = 0;
    },
    resetForm() {
      this.$refs["addOrEditForm"].resetFields();
    },
  },
  computed: {},
  components: {
    AreaTree,
  },

  mounted: function () {},
};
</script>

<style scoped>
.submit {
  text-align: center;
}

.xinjiangunion-api-configure .el-upload__tip {
  height: 30px;
  line-height: 30px;
}
.xinjiangunion-api-configure .el-upload__tip {
  color: red !important;
}
.configure-right {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 50px;
}
.content-right-right {
  width: 40%;
  height: 100%;
  margin: 0 3%;
}
.content-right-left {
  width: 60%;
  height: 100%;
  margin-right: 20px;
}
.content-right-right .upload {
  border: 2px dotted #ddd;
  border-radius: 10px;
  height: 80%;
  display: flex;
  justify-content: center;
  align-items: center;
}
/* .content-right-right{
        display: flex;
        justify-content: center;
        align-items: center;
      
    }*/
.content-right-right-inner {
  height: 60%;
}
.upload-tip {
  color: red;
  margin-top: 10px;
  text-align: left;
}
</style>
<style>
.xinjiangunion-api-configure .content-right .el-input__inner {
  border-radius: 5px;
  height: 50px;
  line-height: 50px;
}
.xinjiangunion-api-configure .el-form-item {
  margin-bottom: 30px;
}
.xinjiangunion-api-configure .el-form-item__label {
  height: 50px;
  line-height: 50px;
  color: #333 !important;
  font-weight: bold;
}
.submit .el-button {
  width: 200px;
  height: 50px;
}
.xinjiangunion-api-configure .el-checkbox__label {
  color: #333 !important;
  font-weight: bold;
}
.xinjiangunion-api-configure .el-upload,
.xinjiangunion-api-configure .el-upload-list {
  float: none !important;
  display: block;
}
</style>